import React from 'react'
import './postBookPage.css'
const PostBookPage = () => {
  return (
    <div>postBookPage</div>
  )
}

export {PostBookPage}